
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.7 36"><path fill="#00c0e8" d="M18 24.03V7.35l8.7 16.67H18Zm0-16.68L9.32 24.03H18V36L0 18l9.23-9.22 1.42-1.42L18.01 0v7.36z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    